import React from "react";

function TableCapexDashboard({ data }) {
  console.log(data, "nibatunga1");
  const tableCellStyle = {
    color: "black",
    border: "2px solid black",
    padding: "3px",
  };

  const tableHeaderStyle = {
    border: "2px solid black",
    padding: "3px",
    background: "#f2f2f2",
  };

  // const headers = data.length > 0 ? Object.keys(data[0]) : [];

  return (
    <div className="col-md-12" style={{ paddingBottom: "70px" }}>
      <table
        style={{ width: "100%", borderCollapse: "collapse" }}
        id="tbl_exporttable_to_xls1"
      >
        <thead>
          <tr>
            {data?.headers?.map((head) => {
              return (
                <th
                  className={"customTh"}
                  style={{ border: "2px solid black !important", color: 'white' }}
                >
                  {head?.label}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data?.data?.map((item) => (
            <tr style={tableCellStyle}>
              {data?.headers?.map((innerItem) => {
                return (
                  <td
                    className={"customTh"}
                    style={{ border: "2px solid black !important" }}
                  >
                    {item[innerItem?.accessor]}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={tableCellStyle}>
            <td
              colSpan={data?.eatCol}
              className={"customTh"}
              style={{ border: "2px solid black !important" }}
            >
              Grand Total
            </td>
            {data?.headers?.slice(data?.eatCol)?.map((head) => {
              return (
                <td
                  className={"customTh"}
                  style={{ border: "2px solid black !important" }}
                >
                  {data.footerData[head?.accessor]}
                </td>
              );
            })}
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default TableCapexDashboard;

export function TableCapexDashboardAdv({ data }) {
  console.log(data, "nibatunga1");


  // const headers = data.length > 0 ? Object.keys(data[0]) : [];

  return (
    <>
      <thead>
        <tr>
          {data?.headers?.map((head) => {
            return (
              <th
                style={{ background: '#143b64', color: '#FFFFFF', fontWeight: 'bold' }}
              >
                {head?.label}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {data?.data?.map((item) => (
          <tr >
            {data?.headers?.map((innerItem) => {
              return (
                <td

                >
                  {item[innerItem?.accessor]}
                </td>
              );
            })}
          </tr>
        ))}

      </tbody>
      <tfoot>
        <tr >
          <td
            colSpan={data?.eatCol}

          >
            <span className="grandtotal" style={{ fontWeight: 'bold' }}>
              Grand Total
            </span>

          </td>
          {data?.headers?.slice(data?.eatCol)?.map((head) => {
            return (
              <td

              >
                {data.footerData[head?.accessor]}
              </td>
            );
          })}
        </tr>
        <tr>
        </tr>
        <tr>
        </tr>

      </tfoot>
    </>
  );
}
